import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import Grid from "@mui/material/Grid";
import Chip from "@mui/material/Chip";

import StyledLine from "components/List/components/StyledLine";
import HeaderContainer from "components/List/components/HeaderContainer";
import IconButton from "components/button/IconButton";
import EditIcon from "components/icons/EditIcon";

const COLUMNS = {
    type: 1.5,
    code: 2,
    pattern: 3.5,
    scope: 1.5,
    reset: 1.5,
    default: 1,
    actions: 1,
};

function Header() {
    return (
        <HeaderContainer>
            <Grid item xs={COLUMNS.type}>
                <FormattedMessage id={'invoiceNumbering.header.type'} />
            </Grid>
            <Grid item xs={COLUMNS.code}>
                <FormattedMessage id={'invoiceNumbering.header.code'} />
            </Grid>
            <Grid item xs={COLUMNS.pattern}>
                <FormattedMessage id={'invoiceNumbering.header.pattern'} />
            </Grid>
            <Grid item xs={COLUMNS.scope}>
                <FormattedMessage id={'invoiceNumbering.header.scope'} />
            </Grid>
            <Grid item xs={COLUMNS.reset}>
                <FormattedMessage id={'invoiceNumbering.header.reset'} />
            </Grid>
            <Grid item xs={COLUMNS.default}>
                <FormattedMessage id={'invoiceNumbering.header.default'} />
            </Grid>
            <Grid item xs={COLUMNS.actions} textAlign={'right'}>
                <FormattedMessage id={'list.header.actions'} />
            </Grid>
        </HeaderContainer>
    );
}

ConfigList.propTypes = {
    items: PropTypes.array.isRequired,
    onEdit: PropTypes.func.isRequired,
};

function ConfigList({items, onEdit}) {
    return (
        <Grid container>
            <Header />
            <Grid item container>
                {items.map((configuration) => (
                    <Grid item container key={configuration.id} sx={{padding: '8px 0'}}>
                        <StyledLine alignItems={'center'}>
                            <Grid item xs={COLUMNS.type}>
                                <FormattedMessage id={`invoiceNumbering.type.${configuration.type}`} />
                            </Grid>
                            <Grid item xs={COLUMNS.code}>
                                {configuration.configurationCode}
                            </Grid>
                            <Grid
                                item
                                xs={COLUMNS.pattern}
                                sx={{fontFamily: 'monospace', overflowWrap: 'anywhere', paddingRight: '8px'}}
                            >
                                {configuration.pattern}
                            </Grid>
                            <Grid item xs={COLUMNS.scope}>
                                <FormattedMessage
                                    id={configuration.perRetailer
                                        ? 'invoiceNumbering.scope.perRetailer'
                                        : 'invoiceNumbering.scope.global'}
                                />
                            </Grid>
                            <Grid item xs={COLUMNS.reset}>
                                <FormattedMessage
                                    id={configuration.perYear
                                        ? 'invoiceNumbering.reset.yearly'
                                        : 'invoiceNumbering.reset.continuous'}
                                />
                            </Grid>
                            <Grid item xs={COLUMNS.default}>
                                {configuration.isDefault && (
                                    <Chip
                                        size={'small'}
                                        color={'primary'}
                                        label={<FormattedMessage id={'invoiceNumbering.badge.default'} />}
                                    />
                                )}
                            </Grid>
                            <Grid item xs={COLUMNS.actions} textAlign={'right'}>
                                <IconButton onMouseDown={(e) => {
                                    e.stopPropagation();
                                    onEdit(configuration);
                                }}>
                                    <EditIcon />
                                </IconButton>
                            </Grid>
                        </StyledLine>
                    </Grid>
                ))}
            </Grid>
        </Grid>
    );
}

export default ConfigList;
